import { Move } from 'lucide-react';
import { DraggableDialog } from '@/components/DraggableDialog';
import { AssetDetailsContent } from './AssetDetails';
import { SelectedFeature, useSelectionStore } from '@/stores/selectionStore';
import { getPrimaryLabelField } from '@/helpers/layerSchema.helpers';

// Reactive based on selected feature in selectionStore

export const AssetDetailsModal = () => {
  const { selected, activeIndex, clear } = useSelectionStore();
  const currentItem = selected[activeIndex];

  const isAsset = currentItem?.layer?.sourceTable === 'assets';
  if (!isAsset || selected.length > 1) return null;

  const assetItem = selected[0];
  const labelField = getPrimaryLabelField(assetItem.layer!.schemaConfig);
  const subtitle = String(
    assetItem.data?.[labelField?.alias ?? 'name'] ?? assetItem.id,
  );

  // Subtitle — layer display name e.g. "Poles", "Manholes"
  const title = assetItem.layer?.displayName ?? '';

  return (
    <DraggableDialog
      panelId={assetItem.id}
      isOpen={true}
      onClose={clear}
      title={title}
      subtitle={subtitle}
      icon={Move}
    >
      <AssetDetailsContent
        assetId={assetItem.id}
        layerDef={assetItem.layer}
        initialData={assetItem.data}
      />
    </DraggableDialog>
  );
};
